import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-day-of-month-question',
  templateUrl: './day-of-month-question.component.html',
  styleUrls: ['./day-of-month-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DayOfMonthQuestionComponent implements OnInit {

  @Input() question: QQQuestionViewModel;
  // @ViewChild('dayInput') dayInput: NgModel;

  days = dayRange(28).map(x => `${x + 1}`);

  constructor() { }

  ngOnInit() {
    if (!this.question.editingValue)
      this.question.editingValue = "";
  }

  async save() {
    this.question.error = null;
    await this.question.setAnswer(this.question.editingValue, true);
  }

}

function dayRange(count: number): number[] {
  return [...new Array(count).keys()];
}
